import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/star.png'


const _hoisted_1 = {
  class: "spread__wrapper",
  ref: "hero"
}
const _hoisted_2 = { class: "spread__wrapper-content" }
const _hoisted_3 = {
  ref: "title",
  class: "spread__title text-h0"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Выберите", -1)
const _hoisted_5 = { class: "spread__title-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Карту", -1)
const _hoisted_7 = {
  ref: "star",
  class: "spread__star"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "star"
}, null, -1)
const _hoisted_9 = {
  ref: "subtitle",
  class: "spread__subtitle"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Мне повезёт", -1)
const _hoisted_11 = {
  ref: "img",
  class: "spread__img",
  style: {"z-index":"1"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_touch_ripple = _resolveComponent("touch-ripple")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spread", { '_cover-header': _ctx.isCoverHeader }]),
    style: _normalizeStyle({ paddingTop: _ctx.paddingTop })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_inline_svg, {
                class: _normalizeClass(["svg-star", { 'active': _ctx.isSvgAnimation }]),
                src: require('@/assets/svg/starBorder.svg'),
                name: "star-4"
              }, null, 8, ["class", "src"])
            ], 512)
          ])
        ], 512),
        _createElementVNode("p", _hoisted_9, " Дракон раскроет тайны вашего будущего с помощью волшебной колоды. Тяните карту и читайте персональное предсказание на 2024 год! ", 512),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.randomCard && _ctx.randomCard(...args)), ["prevent"])),
          ref: "mainBtn",
          class: _normalizeClass(["spread__btn btn-main", { '_disabled': _ctx.isBlockBtn }])
        }, [
          _createVNode(_component_touch_ripple, {
            color: "#859dff",
            opacity: 0.1,
            transition: "ease-out",
            duration: 300,
            "keep-last-ripple": false
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["opacity"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_11, null, 512)
    ], 512)
  ], 6))
}